/**
 * @description: 首页活动
 * @param 
 * @return
 */
import request from "../utils/request";
/**
 * @description: 活动接口
 * @param   {areaId}  产品ID
 * @return 
 */
export const activityList = params => {
    return request.post('/web/operation/activity', params);
};

/**
 * @description: 问卷接口
 * @param   
 * @return 
 */
export const WjList = params => {
    return request.post('/web/operation/wenj', params);
};

/**
 * @description: 公告接口，标记红点
 * @param   {type} 公告类型
 *  @param   {uid} 用户ID
 * @return 
 */
export const circleList = params => {
    return request.post('/web/operation/notice', params);
};

/**
 * @description: 	公告明细接口
 * @param   {id} 公告ID
 *  @param   {uid} 用户ID
 * @param   {needMark} 标记已读
 * @return 
 */
export const noticeList = params => {
    return request.post('/web/operation/getnotice', params);
};

/**
 * @description: 	公告全部标记已读接口
 *  @param   {uid} 用户ID
 * @return 
 */
export const noticeMark = params => {
    return request.post('/web/operation/noticemark', params);
};

/**
 * @description: 	统计小红点数接口
 *  @param   {uid} 用户ID
 * @param {type} 公告类型
 * @return 
 */
export const countMark = params => {
    return request.post('/web/operation/countmark', params);
};



// WEBPACK FOOTER //
// src/api/activity.js